import { COLOR_GREEN, COLOR_RED} from '../../constants'
import { useImportedPlayers } from '../../../../../providers/ImportedPlayersProvider';
import { useHomebrewProvider } from '../../../../../providers/HomebrewProvider';
import 'react-tabs/style/react-tabs.css';
import { useEffect, useState } from 'react';

const alignmentOptions = [
    'good', 'evil', 'neutral',
    'true', 'unaligned', 'lawful',
    'chaotic', 'lawful good', 'neutral good',
    'chaotic good', 'lawful neutral', 
    'true neutral', 'chaotic neutral',
    'lawful evil','nuetral evil',
    'chaotic evil','unaligned' 
]

function getKey(c) {
    let keyExtra = ""
    if(c?.from === 'dnd_b')
        keyExtra = c.dnd_b_player_id
    else if(c?.dmb_homebrew_guid)
        keyExtra = c?.dmb_homebrew_guid
    else 
        keyExtra = c.sourceShort

    return c.name + keyExtra;
}

function escapeRegExp(string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // Escape special characters
}

function highlightSubstring(substring, fullString) {
    if (!substring) return fullString;
    const parts = fullString.split(new RegExp(`(${escapeRegExp(substring)})`, 'gi')); // Split on the substring, keeping it in the result

    return (
        <span>
            {parts.map((part, index) =>
                part.toLowerCase() === substring.toLowerCase() ? (
                    <b key={index} style={{
                        textShadow: '1px 1px 2px gray',
                    }}>{part}</b> 
                ) : (
                    part 
                )
            )}
        </span>
    );
}

// For monster and homebrew Tabs
const SearchTabMonsterItem = ({creature, index, handleSearchSelectCreature, searchTerm}) => {    
    const {removeFromImportList} = useImportedPlayers();
    const {removeFromHomebrewList} = useHomebrewProvider();
    const [xClicked, setXClicked] = useState({click: false, index: undefined});
    const [shake, setShake] = useState(undefined);
    const [groupCount, setGroupCount] = useState(1);

    useEffect(() => {
        if(shake) {
            setTimeout(() => {
                setShake(undefined)
            }, 2000)
        }
    }, [shake])

    useEffect(() => {
        if(xClicked.click) {
            setTimeout(() => {
                setXClicked({click: false, index: undefined})
            }, 2000)
        }

    }, [xClicked])

    const handleXClick = async (c, index) => {
        let handled = c?.dnd_b_player_id 
                        ? await removeFromImportList(c, index)
                        : await removeFromHomebrewList(c, index)

        if(handled) { 
            setXClicked({click: true, index})
        }
    }

    const colors = {
        "enemy": COLOR_RED,
        "neutral": '#999999',
        "ally": COLOR_GREEN,
        "pet": COLOR_GREEN
    }

    const clickGroupCount = (num, e) => {
        e.stopPropagation()
        if(groupCount === 1 && num === -1)
            return 

        setGroupCount(groupCount + num)
    }

    //tabSelectedIndex === 0
    return (
        <li
            className="listItem"
            key={getKey(creature)}
            onClick={(e) => handleSearchSelectCreature(creature, "select", e)}
        >
            <div className={`searchListCreatureContainer ${(xClicked.click && index > xClicked.index) ? "animated-box" : ""}`}
                style={creature?.alignment ? {borderLeft: `6px solid ${colors[creature?.alignment]}`} : {}}>
                <div className="monsterEncounterIconContainer">
                    <img className="monsterSearchIcon" src={creature.avatarUrl} alt={"list Icon"} />
                </div>
                <div className='searchListCreatureDetails'>
                    <span>
                        <strong>{highlightSubstring(searchTerm, creature.name)}</strong>  
                    </span>
                    <div className='searchCreatureSmallDetails'>
                        {creature?.dmb_homebrew_guid ? (
                            <>
                                <span className='monsterSearchDetailText'> CR: {creature.challenge_rating}</span>
                                {creature?.creature_type !== "--" && <span className='monsterSearchDetailText'> - {highlightSubstring(searchTerm, creature.creature_type)}</span>}
                                <span className='monsterSearchDetailText'> - {creature?.dmb_homebrew_guid}</span>
                                <span className='monsterSearchDetailText'> - {creature?.alignment}</span>
                            </>
                        ) : (
                            <>
                                <span className='monsterSearchDetailText'> CR: {creature.cr}</span>
                                <span className='monsterSearchDetailText'> - {highlightSubstring(searchTerm, creature.creature_type)}</span>
                                <span className='monsterSearchDetailText'> - {creature.sourceShort}</span>
                                {(searchTerm.length >= 4 && alignmentOptions.includes(searchTerm.toLowerCase())) && 
                                    <span className='monsterSearchDetailText' style={{textShadow: '1px 1px 2px gray',}}> 
                                        - <b>{searchTerm.toLowerCase()}</b>
                                    </span>
                                }
                            </>
                        )}
                    </div>
                </div>
                <div className='searchListButtonContainer'>
                    {creature?.dmb_homebrew_guid &&
                        <button className='searchCreatureX' onClick={(event) => {
                            event.stopPropagation();
                            handleXClick(creature, index) ;
                        }}>
                            ❌
                        </button>
                    }
                    <div className='monsterAddContainer'>
                        <button className='monsterSearchAdd' title={`Add ${groupCount}x '${creature.name}${groupCount > 1 && "s"}' to Encounter`} onClick={(e) => handleSearchSelectCreature(creature, "add", e, groupCount)}>
                            ➕
                        </button>
                        <div className='groupButtonContainer'>
                            <div className='groupButton' title={"Group +1 " + creature.name} onClick={(e)=> clickGroupCount(1, e)}><b> + </b></div>
                            <div className='groupCount' onClick={(e) => e.stopPropagation()}><b>{groupCount}</b></div>
                            <div className='groupButton' title={"Group -1 " + creature.name} onClick={(e)=> clickGroupCount(-1, e)}><b> - </b></div>
                        </div>
                    </div>

                </div>

            </div>
        </li>
    );
}

export default SearchTabMonsterItem;